import comp from "./FieldAIEvaluation";
export default comp;
